import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SectionTypeEnum } from '@seb/web-design-system/core';

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  private subject = new Subject<SectionTypeEnum>();

  dispatchClickSectionEvent(type: SectionTypeEnum) {
    this.subject.next(type);
  }

  onClickSection(): Observable<any> {
    return this.subject.asObservable();
  }
}
